<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn 
            icon
            :disabled="disabled"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </template>
        <span>Cancel application</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-text> Are you sure you want to cancel this leave application? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      leaveApplicationId: {
        type: Number,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.leaveApplications().cancel(this.leaveApplicationId)
          .then(response => {
            if (response.status === 200) {
              this.$emit('cancelled')
              this.$snack({ message: response.data.status })

              this.menu = false
            }
          })
          .catch(error => {
            let message = 'Failed to cancel'

            if (error && error.response && error.response.data) {
              if (error.response.data.message) {
                message = error.response.data.message
              } else if (error.response.data.status) {
                message = error.response.data.status
              }
            }

            this.$snack({ 
              color: 'error',
              message: message, 
            })
          })
          .then(() => {          
            this.progressing = false
          })    
      },
    },
  }
</script>
